import ReactComponent from '../app/ReactComponent'
import {Button, Card, Col, Image, List, Row, Space} from 'antd'
import {TeamOutlined} from '@ant-design/icons'
import dayjs from 'dayjs'
import {Link} from 'react-router-dom'
import GParallax from '../components/helpers/GParallax'
import {$t} from '../app'
import VulcanicLandscapeImage from '../gfx/DJI_0149@small.jpg'
import ContactSection from '../components/parts/ContactSection'
import {$language} from '../app/Languages'

export default class EventsOverviewPage extends ReactComponent {
  state = {
    tours: [],
    pagination: {
      defaultCurrent: 1,
      total: 0,
      defaultPageSize: 5,
      current: 1
    }
  }

  async componentDidMount() {

    this.scrollToTop()

    void this.getTours(0, 100)

  }

  async getTours(offset = 0, limit = 10) {
    const active_lang = $language().$language()

    const data = await this.$app.$directus('tours', {
      fields: ['*', {translations: ['name', 'content']}, {featured_image: ['*']}],
      filter: {
        start_date: {
          '_gt': '$NOW'
        }
      },
      deep: {
        translations: {
          _filter: {
            languages_code: {'_eq': active_lang}
          }
        }
      },
      meta: 'filter_count'
    })

    const tours = data.map(({translations, ...tour}) => ({
      ...translations[0],
      ...tour
    }))

    console.log(data)
    void this.updateState({tours: tours})

  }

  render() {
    return (
      <>
        <section className="fullwidth centered">

          <GParallax speed={-3} options={{y: 0}} scrollTrigger={{start: 'top top'}} className="fullwidth-background">
            <Image src={VulcanicLandscapeImage} preview={false} style={{opacity: 0.8, objectPosition: 'center center'}}/>
          </GParallax>

          <Row align="bottom" justify="end" gutter={[0, 0]} style={{minHeight: 'inherit'}}>
            <Col span={24}>
              <div className="container centered mb-2">
                <GParallax speed={1} options={{y: 0}}>
                  <h1 className="h1 text-grad mb-1"><$t _="tourspage_title" /></h1>
                </GParallax>
              </div>
            </Col>
          </Row>

          <div className="hero-gradient-bottom"></div>
        </section>

        <section className="container centered">

          <p className="mt-3 _grey-primary-text mb-4"><$t _="tourspage_description" /></p>

          <List
            itemLayout="vertical"
            dataSource={this.state.tours}
            /*pagination={{
              ...this.state.pagination,
              defaultPageSize: 10,
              showSizeChanger: false,
              align: 'center'
            }}*/
            split={false}

            renderItem={(item) => (
              <List.Item
                key={item.id}
                actions={[]}
              >
                <Card className="grad no-padding">
                  <Row gutter={0}>
                    <Col sm={24} md={6} lg={7}>
                      <Image src={`https://trailsoficeandfire.dobiland.com/assets/${item.featured_image.id}?quality=30`} preview={false}/>
                    </Col>
                    <Col flex="auto" className="pa-3">
                      <h3>{item.name}</h3>
                      <p className="_grey-primary-text fs-smaller">{`${dayjs(item.start_date).format('D.M.YYYY')} - ${dayjs(item.end_date).format('D.M.YYYY')}`}</p>


                      <Row justify="space-between" gutter={[16, 16]} className="mt-2">
                        {/*<Col>
                          <Space><TeamOutlined/> <span>0/{item.capacity} kapacita</span></Space>
                        </Col>*/}
                        <Col xs={24} sm={24} md={{flex: 'none'}} className="ta-right">
                          <div className="dib card-actions">
                            <Link to={`/events/${item.id}`}>
                              <Button type="primary">Detail</Button>
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Card>
              </List.Item>
            )}
          />
        </section>

        <ContactSection />
      </>
    )
  }
}